module.exports = __webpack_public_path__ + "img/FUT_poznan_.a3db6aef.png";